export function playVideoWithErrorHandler(videoElement: HTMLVideoElement) {
  if (videoElement == null) {
    return null;
  }
  const playPromise = videoElement.play();
  if (playPromise != null) {
    playPromise.then(() => null).catch(() => null);
  }
  return playPromise;
}
